import type { FetcherType } from '@/app/_shared/utils/fetcher/types';
import type { IncomingHttpHeaders } from 'node:http';
import type { CategoryOverviewV3Response, DisplayHomeResponse } from '@weberus/shared-types';
import { fetcher } from '@/app/_shared/utils/fetcher';

export const fetchHome = (fetcher: FetcherType) => (headers?: IncomingHttpHeaders) => {
  return fetcher<DisplayHomeResponse>({
    method: 'POST',
    url: '/display-site/home',
    headers: headers as Record<string, string>,
  });
};

export const fetchCategoryOverviewV3 = async (headers?: Headers) => {
  return fetcher<CategoryOverviewV3Response>({ method: 'GET', url: '/display-site/v3/category-overview', headers });
};
